<script>
  import {onMount } from 'svelte';
  import StandardHeader from "./StandardHeader.svelte"
  import StandardFooter from "./StandardFooter.svelte"

  import { Switch, MaterialApp } from 'svelte-materialify';
  // let beta = false;
  let beta

  onMount(async () => {
    if (localStorage.getItem('MoodFirstBeta') == 'true') {
      beta = true
    }
  })

  $:{
    if (beta == true) {
      localStorage.setItem('MoodFirstBeta', 'true')
    }
    else if (beta == false){
        localStorage.removeItem('MoodFirstBeta')
    }
  }

</script>
<div class="pageContainer">
  <StandardHeader />

  <div class="mainContentSection">
    <h1 class="heading">Beta Programme</h1>
    <MaterialApp>
      <br />
      <div Xclass="d-flex justify-space-around">
        <Switch bind:checked={beta} color="#34C7C8" value="true">Enable Beta Features For This Browser</Switch>
      </div>
    </MaterialApp>
  </div>

  <StandardFooter />
</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px); margin-left: 6%; margin-right: 6%; }

.heading{font-family: Poppins, sans-serif; color: #255991; font-size: 36px; font-weight: 700;}
</style>
